<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      Invoices
    </h1>
    <p class="subheader-style">
      List of all invoices
    </p>
    <v-btn
      v-if="permissionCheck"
      class="floating-add-button"
      color="#64CA7F"
      elevation="0"
      fab
      @click="showModal = true"
    >
      <v-icon color="#ffffff">
        mdi-text-box-plus-outline
      </v-icon>
    </v-btn>
    <div>
      <v-tabs
        v-model="tab"
        class="tab-style mt-5"
        rounded
        color="transparent"
        active-class="selected-tab"
        light
      >
        <v-tab
          class="tab-outstanding"
        >
          <v-icon size="15">
            mdi-star
          </v-icon> Outstanding
        </v-tab>
        <v-tab
          class="tab-paid"
        >
          <v-icon size="15">
            mdi-check-circle-outline
          </v-icon> Paid
        </v-tab>
        <v-tab
          class="tab-draft"
        >
          <v-icon size="15">
            mdi-file-document-outline
          </v-icon> Draft
        </v-tab>
        <v-spacer />
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="my-tabs-background-style"
        touchless
      >
        <v-tab-item>
          <v-card-text>
            <outstanding-invoices />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <paid-invoices />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <draft-invoices />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <br>
      <br>
      <invoice-create-form
        v-if="showModal"
        @closed="showModal = false"
      />
    </div>
  </div>
</template>
<script>
import OutstandingInvoices from './dialogComponents/invoiceDialogs/OutstandingInvoices.vue';
import PaidInvoices from './dialogComponents/invoiceDialogs/PaidInvoices.vue';
import InvoiceCreateForm from './dialogComponents/invoiceDialogs/InvoiceCreateForm.vue';
import DraftInvoices from './dialogComponents/invoiceDialogs/DraftInvoices.vue';
export default {
  name: 'JobsPage',
  components: {
    'outstanding-invoices': OutstandingInvoices,
    'paid-invoices': PaidInvoices,
    'invoice-create-form': InvoiceCreateForm,
    'draft-invoices': DraftInvoices,
  },
  data: () => ({
    tab: null,
    showModal: false,
  }),
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    permissionCheck () {
      return (
        this.selectedOrganization !== null &&
        this.selectedOrganization.app_user_role === 'contractor'
      );
    },
  },
};
</script>
<style scoped>
.from-style {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.my-tabs-background-style {
  background-color: transparent;
}

.v-item-group
  theme--dark
  v-slide-group
  v-tabs-bar
  v-tabs-bar--is-mobile
  primary--text {
  width: 100%;
}

.v-slide-group__content v-tabs-bar__content {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.v-tabs-slider-wrapper {
  background-color: transparent !important;
}

.v-tab {
  color: #000000 !important;
  border-radius: 10px;
  height: 30px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  gap: 10px;
  background: #FFF;
}

.v-tab.tab-outstanding {
  width: 50% !important;
  border: 1px solid #8abceb;
}

.v-tab--active.tab-outstanding {
  color: #ffffff !important;
  background: #8abceb;
  border: none;
}

.v-tab.tab-draft {
  width: 40% !important;
  border: 1px solid #ffca68;
}

.v-tab--active.tab-draft {
  color: #ffffff !important;
  background: #ffca68;
  border: none;
}

.v-tab.tab-paid {
  width: 40% !important;
  border: 1px solid #63ca7f;
}

.v-tab--active.tab-paid {
  color: #ffffff !important;
  background: #63ca7f;
  border: none;
}

.selected-tab {
  color: #fff;
}

.v-tab {
  font-size: 10px !important;
}

.v-card__text {
  padding: 0px !important;
}
:deep(.v-slide-group__prev),
:deep(.v-slide-group__next) {
  display: none !important;
}

.floating-add-button {
  position: fixed;
  bottom: 70px !important;
  right: 10px;
  z-index: 1;
}
</style>
